import * as Q from 'q';
import { VASRestService } from '../../core/services/api/vas-rest';
import { IUserService } from '../../core/services/user-service.interface';
import { LoggedInEvent } from '../../core/system/system.actions';
import { UserService } from '../services/user/user.service';
import { IVasAppFacade } from '../services/vas-app-facade.service.interface';

export interface LoginOptions {
    silence: boolean;
}

export class AuthFacade {

    protected service: IUserService;

    constructor(
        protected appFacade: IVasAppFacade,
        protected apiService: VASRestService
    ) {
        this.service = new UserService(appFacade, apiService);

        this.service.busy$.subscribe(busy => {
            if (busy) {
                this.appFacade.loading.showLoading();
            } else {
                this.appFacade.loading.hideLoading();
            }
        });

        this.service.error$.subscribe(error => this.appFacade.toast.toastDanger(error));
    }

    login(email: string, password: string, options: LoginOptions = {silence: false}): Promise<any> {

        return new Promise((resolve, reject) => {
            [
                () => this.appFacade.loading.showLoading(),
                () => this.appFacade.network.refreshStatusP(),
                () => this.service.login(email, password)
            ].reduce<any>(Q.when, Q()).then(
                user => {
                    this.appFacade.loading.hideLoading();
                    if (!options.silence) {
                        this.appFacade.triggerSystemEvent(new LoggedInEvent());
                    }
                    resolve(user);
                },
                error => {
                    this.appFacade.loading.hideLoading();
                    this.appFacade.toast.toastDanger(error);
                    reject(error);
                }
            );
        });
    }

    logout(): void {
        this.service.logout();
    }
}



// WEBPACK FOOTER //
// ./src/vas/facades/auth-facade.ts